import { RhLink } from "@components";
import className from 'classnames/bind';
import { SplideSlide } from 'react-splide-ts';
import { RecentPostsQuery } from "@graphqlTypes";
import { TypePill, Image } from '@components';

import styles from './CarouselStories.module.scss';
const cx = className.bind(styles);

type SlideProps = {
  story: RecentPostsQuery['posts']['nodes'][number];
  index: number;
};

export default function Slide({ story, index }: SlideProps) {
  const { title, pageData, featureData: storyData } = story;
  const { excerpt } = storyData;
  const { featuredImage } = pageData;

  // -------------------- Render

  return (
    <SplideSlide className={cx('story-carousel-slide')} aria-label={title}>
      <RhLink href={story.uri} className={cx('link')}>

        {/* Image */}
        <div className={cx('image-container')}>
          {/*<TypePill className={cx('type')} type={pillType.key} copy={pillType.label} />*/}
          <Image image={featuredImage} />
        </div>

        {/* Texts */}
        <div className={cx('content')}>
          <p className={cx('title-lc-m', 'sub-headline')} dangerouslySetInnerHTML={{ __html: title }} />
          <p className={cx('text-m')}>
            {excerpt}
          </p>
        </div>

      </RhLink>
    </SplideSlide>
  );

};